<template>
  <div v-if="articlesData">
    <ArticlesTitle :articlesData="articlesData"></ArticlesTitle>
    <Crumbs :articlesData="articlesData"></Crumbs>
    <!-- <ArticlesContent></ArticlesContent> -->
    <div class="ArticlesContent">
      <div class="ArticlesContent_con">
        <div class="ArticlesContent_top" ref="element_">
          <ArticlesLeft :articlesData="articlesData"></ArticlesLeft>
          <ArticlesRight
            v-if="terminal == 'pc'"
            :relatedNews="relatedNews"

          ></ArticlesRight>
        </div>
      </div>
      <ArticlesBottom
        :otherNews="otherNews"
      ></ArticlesBottom>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import { getArticlesInfo } from "@/axios/api.js";
import { news, relatedNews, otherNews } from "@/axios/news.js";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  name: "Articles",
  data() {
    return {
      articlesData: null,
      likeArticles: null,
      otherNews: null,
      relatedNews: null,
    };
  },
  mounted() {
    var articlesId = this.$route.query.id;
    this.getArticlesInfoFun(articlesId);
  },
  watch: {
    language(){
      this.$router.push('/')
    },
    $route: {
      // $route可以用引号，也可以不用引号
      handler(to, from) {
        var articlesId = this.$route.query.id;
        this.getArticlesInfoFun(articlesId);
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    async getArticlesInfoFun(articlesId) {
      var res = await getArticlesInfo(articlesId);
      this.articlesData = res.data.data[0];
      console.log(this.articlesData);
      this.getChannelName(this.articlesData.id);
    },
    async getChannelName(id) {

      var otherNewsList = await relatedNews(id);
      var relatedNewsList = await otherNews(id);
            console.log(otherNewsList);
      this.$nextTick(() => {
        var heightStyle = this.$refs.element_.offsetHeight; // 100px
        this.otherNews = otherNewsList.data.data.slice(0, 4);
        this.relatedNews = relatedNewsList.data.data.slice(
          0,
          Math.floor(heightStyle / 223) - 1
        );
      });
    },
  },
  components: {
    ArticlesTitle: () =>
      import("../components/Articles/ArticlesTitle/ArticlesTitle.vue"),
    Crumbs: () => import("../components/Articles/Crumbs/Crumbs.vue"),
    ArticlesLeft: () =>
      import("../components/Articles/ArticlesContent/ArticlesLeft.vue"),
    ArticlesRight: () =>
      import("../components/Articles/ArticlesContent/ArticlesRight.vue"),
    ArticlesBottom: () =>
      import("../components/Articles/ArticlesContent/ArticlesBottom.vue"),
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .ArticlesContent {
    width: 100%;
    background: url("../assets/image/Articles/bg.jpg");
    background-size: 100% 2000px;
    .ArticlesContent_con {
      min-height: 600px;
      border-bottom: 2px solid #ccc;
      .ArticlesContent_top {
        margin-bottom: 20px;
        line-height: 30px;
        padding: 40px 0;
        width: 1200px;
        margin: auto;
        display: flex;
        flex-direction: row;
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .ArticlesContent {
    width: 100%;
    background: url("../assets/image/Articles/bg.jpg");
    background-size: 100% 2000px;
    .ArticlesContent_con {
      min-height: 600px;
      border-bottom: 2px solid #ccc;
      .ArticlesContent_top {
        margin-bottom: 20px;
        line-height: 30px;
        padding: 40px 0;
        width: 1200px;
        margin: auto;
        display: flex;
        flex-direction: row;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .ArticlesContent {
    width: 100%;
    background: url("../assets/image/Articles/bg.jpg");
    background-size: 100% 2000px;
    .ArticlesContent_con {
      min-height: 600px;
      border-bottom: 2px solid #ccc;
      .ArticlesContent_top {
        margin-bottom: 20px;
        line-height: 30px;
        padding: 10px 0;
        width: 100%;
        margin: auto;
        display: flex;
        flex-direction: row;
      }
    }
  }
}
</style>